import { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Modal, ModalProps, Row, Spin, Upload, UploadFile, message } from 'antd'
import axios from 'axios'
import styles from './index.module.less'
import { UploadOutlined } from '@ant-design/icons'

export interface Props {
  open: ModalProps['open']
  onCancel?: ModalProps['onCancel']
  onOk:  any
}

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
}

const Index = ({ open, onCancel, onOk }: Props) => {
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState<UploadFile[]>([])
  const [uploadFile, setFile] = useState<File>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const uploadProps = {
    maxCount: 1,
    // action: 'otherapi/api/file-upload',
    // data: { area: form.getFieldValue('area')},
    beforeUpload: (file) => {
      setFile(file)
      return false
    },
    onChange: ({ fileList: newFileList }) => setFileList(newFileList)
  }

  const handleOk = async () => {
    setLoading(true)
    try {
      const formData = await form.validateFields()
      const postData = {
        ...formData,
        file: uploadFile,
      } as any
      const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
      }
      const result = await axios.post('otherapi/api/file-upload', {...postData}, config).then(res => {
        return res?.data
      })
      if (result?.data) {
        onOk(result?.data)
      } else {
        message.error(result?.msg)
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!open) {
      form.resetFields()
      setFile(null)
      setFileList([])
    }
  }, [open])

  const handleCancel = () => {
    onCancel(null)
  }

  return (
    <Modal
      width='560px'
      maskClosable={false} // 防止误操作
      destroyOnClose
      wrapClassName={styles.container}
      title='上传'
      open={open}
      onOk={handleOk}
      onClose={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      <Spin spinning={isLoading}>
      <div className={styles.container}>
        <Form form={form} {...layout}>
          <Row gutter={24}>
            <Col span={24} >
              <Form.Item label='地址' name='area'  rules={[{ required: true, message: '请输入'}]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24} >
              <Form.Item label='中交项目id' name='zjProjectid'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24} >
              <Form.Item label='文件' name='file' required rules={[{validator: () => fileList.length ? Promise.resolve() : Promise.reject(), message: '请选择'}]} >
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>上传</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>  
        </Form>

        <div className={styles.footer}>
          <Button size='middle' onClick={handleCancel} className={styles.btnCancel}>
            取消
          </Button>
          <Button size='middle' onClick={handleOk} type='primary' className={styles.btnOk}>
            确定
          </Button>
        </div>
      </div>
      </Spin>
    </Modal>
  )
}
export default Index
